<template>
  <section class="section section-shaped section-lg my-0">
    <div class="shape shape-style-1 bg-gradient-default">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div class="container pt-lg-md">
      <div class="row justify-content-center">
        <div class="col-lg-5">
          <card type="secondary" shadow
                header-classes="bg-white pb-5"
                body-classes="px-lg-5 py-lg-5"
                class="border-0">
            <template>
              <div v-if="login_errado" class="alert alert-danger" role="alert">
                Número de inscrição ou CPF inválido.
              </div>
              <div class="text-muted text-center mb-3">
                <small>Entre com:</small>
              </div>
              <div class="btn-wrapper text-center">
              </div>
            </template>
            <template>
              <form @submit.prevent="envia_login" role="form">
                <base-input v-model="username" alternative
                            class="mb-3"
                            v-mask="'#######-#'"
                            placeholder="Número de inscrição"
                            addon-left-icon="ni ni-single-02">
                </base-input>
                <base-input v-mask="'###.###.###-##'" v-model="password" alternative

                            placeholder="CPF"
                            addon-left-icon="ni ni-badge">
                </base-input>

                <div class="text-center">
                  <base-button native-type="submit" type="primary" class="my-4">Entrar</base-button>
                </div>
              </form>
            </template>
          </card>
          <div class="row mt-3">
            <div class="col-6">
              <a href="#" class="text-light">
                <!--                <small>Esqueci minha senha</small>-->
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import axios from 'axios';
import {useRouter} from 'vue-router';
import Vue from 'vue'
import vueCrypt from 'vue-crypt'
import {cpf} from "cpf-cnpj-validator";

export default {
  name: 'Login',
  data() {
    return {
      username: '',
      password: '',
      login_errado: false,
      logins: [{cpf: 321., num_cand: 123}]
    }
  },
  methods: {
    envia_login: async function () {

      const encryptedText = this.CryptoJS.AES.encrypt("Hi There!", 'secret key 123').toString()
      const decryptedText = this.CryptoJS.AES.decrypt('U2FsdGVkX1+rGzJrqd1xvB4s0Sxxmcl9dbo4sUwcMsE=', 'secret key 123').toString(this.CryptoJS.enc.Utf8)

      const encrypt = (texto) => {
        return this.CryptoJS.AES.encrypt(texto, 'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString()
      }
      const decrypt = (texto) => {
        return this.CryptoJS.AES.decrypt(texto, 'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString(this.CryptoJS.enc.Utf8);
      }

      const gera_file_name = (cpf, num_cand) => {

        let candidato = {CPF: cpf, NUMEROINSC: num_cand}
        let cod_projeto = '2106_pt'
        let codigo_meio = candidato.CPF.replace(/\./g, '').replace('-', '') * 7919;
        codigo_meio = codigo_meio.toString()

        let codigo_arquivo = parseInt(codigo_meio.substring(0, 5)) * parseInt(candidato.NUMEROINSC.replace('-', '')) * 13 + '_'
            + String.fromCharCode(65 + parseInt(codigo_meio[3]))
            + String.fromCharCode(parseInt(codigo_meio[1] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[1]))
            + String.fromCharCode(parseInt(codigo_meio[4] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[5]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[2]))
            + String.fromCharCode(parseInt(codigo_meio[7] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[7]))
            + '-'
            + String.fromCharCode(parseInt(codigo_meio[0] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[11]))
            + String.fromCharCode(parseInt(codigo_meio[1] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[9]))
            + String.fromCharCode(parseInt(codigo_meio[5] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[4]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[5]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[8]))
            + '_'
            + String.fromCharCode(parseInt(codigo_meio[2] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[3]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[4]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[6]))
            + String.fromCharCode(parseInt(codigo_meio[6] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[2]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[11]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[9]))

        return codigo_arquivo + '.pdf';
      }


      let cands =
[{"num_cand":"U2FsdGVkX19ZY1hTmIKrFHukbCeRNloNgok2Pwq2wms=","cpf":"U2FsdGVkX1/2U0yjXsf0WftCfMg96PMu84o/d3QbUyM="},{"num_cand":"U2FsdGVkX1/pMkiG1HPRYZzuP/uY999hZ1rP1J461YU=","cpf":"U2FsdGVkX18yqI6BhXBAua1pKjSxqnKhcBXGCApjhIQ="},{"num_cand":"U2FsdGVkX1+/Vw9m1W0fJn2k8zVODcf2eaJF1f5JmgQ=","cpf":"U2FsdGVkX19pGQz5mvXmfqNVpKrF5fl/LATJfYSLvfE="},{"num_cand":"U2FsdGVkX1/+4p9Dk1899U422O4k9qN+6JJWmWPQ0r4=","cpf":"U2FsdGVkX18BJ9/htU3X0ScFbl2QBm6S5dY89CYvEq0="},{"num_cand":"U2FsdGVkX18lchImmDh8yFUin8WDdyt4WtOpjnDj1NU=","cpf":"U2FsdGVkX1+wv2Bu82pWoyeCFVML24r9IZbxLxLOZjw="},{"num_cand":"U2FsdGVkX18ZM4+zuPYNUVSDKY/b/tI14mqYuGRgDiA=","cpf":"U2FsdGVkX1+HY3pEZf5oNnL0S+cZpFS611ObzBLzSv8="},{"num_cand":"U2FsdGVkX19yAnvk46r/LKBUwIAhFrgCP4YHQQHyChU=","cpf":"U2FsdGVkX1/Oii+2ZzqaICtQDXY9EdLU7u6qzMcQ9t4="},{"num_cand":"U2FsdGVkX1/34vSRc8h3urmf8TZpcbpXVj0BdQJHeFE=","cpf":"U2FsdGVkX187GD4OHBBlXjx0nWTfDB5Qe2QrhNagvMw="},{"num_cand":"U2FsdGVkX18dM2zWcbs43zAUrdedmIhzjiy4evMpwBk=","cpf":"U2FsdGVkX18ttBX5Qbgg0pLQ611gdH5uo7zJAXv23W4="},{"num_cand":"U2FsdGVkX1+V3xKash6yL5u8tdOGVIhPzoZVAHcOnSE=","cpf":"U2FsdGVkX18sUPJU1aGVtU8NplEigcDv7exQyBiV+JA="},{"num_cand":"U2FsdGVkX19YyQ2DpcPCxDbduJ0bxtzTaIK+dTNAWR4=","cpf":"U2FsdGVkX1///0YuMJHKWSRyvLGKG/GSpEJKryRHOAY="},{"num_cand":"U2FsdGVkX1+/A/jlKJCR9b8NnMDVBsY+NOrbKqFTqBc=","cpf":"U2FsdGVkX1+v0rmCYZjiw6FY1yNSbRzvXqBLEBLGv4g="},{"num_cand":"U2FsdGVkX19layg4K1AJd/zVsJwWMJA72ghWR+0T5Dc=","cpf":"U2FsdGVkX18Nhl/9yup0xkeo+Imsfy1oA0x017Dl7M0="},{"num_cand":"U2FsdGVkX1/ZzI5umV/MFOgIad3pa63rVoAm5tejGl4=","cpf":"U2FsdGVkX19hudfd83EncFKV3UftxIOTaYGPtOKj63k="},{"num_cand":"U2FsdGVkX1+6Nvy+bmM85ecbY/Y0dPkZBFQ0GrP7PuU=","cpf":"U2FsdGVkX19v7bva2HSGOmL3BE6mvhpaDZSZWLlFgCM="},{"num_cand":"U2FsdGVkX1/9pkoLTxtaNwM9JtvtJSngSetvF1Vhcr8=","cpf":"U2FsdGVkX1+hLC7BjP3VTwGEq8/0BjZQ5n5X1RzYGCo="},{"num_cand":"U2FsdGVkX198roAKjLkmIkaeLU9ZLXF4/3oX8bFW0zM=","cpf":"U2FsdGVkX19Kq22ikfMiaFVHGAoWH2bIduOIa0kDAEI="},{"num_cand":"U2FsdGVkX1863/aSHxC/d/+LTzVYT3XEFYv9WL9vSd8=","cpf":"U2FsdGVkX1+bTmsiHswq7eb0Nnw1Np8tVt1wZtE3UJM="}]
      try {
        let concurso = this.$route.params.concurso;
        localStorage.setItem('concurso', concurso);

        for (let login of cands) {
          let num_cand_decripted = decrypt(login.num_cand);
          let cpf_decripted = decrypt(login.cpf);

          // console.log(num_cand_decripted,cpf_decripted)
          if (num_cand_decripted == this.username && cpf_decripted == this.password) {
            console.log(`Logged`)
            let nome_arquivo = (gera_file_name(cpf_decripted, num_cand_decripted))
            nome_arquivo = nome_arquivo.replace(/\x00/g, '-');


            // alert(`Logou`);
            let url = (`https://fs.ibfc.org.br/arquivos/2203/res_exame/${nome_arquivo}`)
            return window.location = url;
          }
        }

        throw new Error(`Login inválido`);


      } catch (error) {
        console.log(error);
        this.login_errado = true;
      }
    }
  }
};
</script>
<style>
</style>
